import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import tastePanelDataAccess, { TastePanelListItem } from "src/dataAccess/tastePanel/tastePanel.DataAccess";

// Actions
export const getTastePanelListSuccess = createAction<{ data: TastePanelListItem[]; dataCount: number }>(
  "[TastePanel] Get TastePanel List Success"
);
export const loadingTastePanelData = createAction<boolean>("[TastePanel] Loading data");
export const loadingTastePanelList = createAction<boolean>("[TastePanel] Loading list");

// Thunks
export const getTastePanelListAsync = createAsyncThunk<{ data: TastePanelListItem[]; dataCount: number }, IListType>(
  "[TastePanel] Get TastePanel List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingTastePanelList(true));
    const result = await tastePanelDataAccess
      .getTastePanelList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getTastePanelListSuccess(res));
        thunkAPI.dispatch(loadingTastePanelList(false));
        return res;
      });
    return result;
  }
);

export const saveTastePanelListSuccess = createAction<TastePanelListItem[]>(
  "[TastePanel] Save TastePanel Success"
);

export const saveTastePanelListAsync = createAsyncThunk<
  TastePanelListItem,
  { tastePanelId: any; data: TastePanelListItem; tastePanelList: Array<TastePanelListItem> }
>("[TastePanel] Save TastePanel", async (parameter, thunkAPI) => {
  const { tastePanelId, data, tastePanelList } = parameter;
  thunkAPI.dispatch(loadingTastePanelList(true));
  let updatedTastePanelList: TastePanelListItem[];
  if (tastePanelId === "edit") {
    let copyTastePanelList = [...tastePanelList];
    updatedTastePanelList = (copyTastePanelList ?? []).map((item) => {
      let copyItem = { ...item };
      if (copyItem.id === data.id) {
        copyItem = data;
      }
      return copyItem;
    });
  } else {
    let copyTastePanelList = [...tastePanelList];
    updatedTastePanelList = [...copyTastePanelList, data];
  }
  thunkAPI.dispatch(saveTastePanelListSuccess(updatedTastePanelList));
  thunkAPI.dispatch(loadingTastePanelList(false));
  return data;
});

export const deleteTastePanelSuccess = createAction<string>("[TastePanel] Delete TastePanel Success");

export const deleteTastePanelAsync = createAsyncThunk<
  { success: boolean; message: string; id: string },
  string
>(
  "[TastePanel] Delete TastePanel",
  async (id, thunkAPI) => {
    const res = await tastePanelDataAccess.deleteTastePanelInfo(id);
    return { ...res, id };
  }
);

export const deleteTastePanelsBulkAsync = createAsyncThunk<
  { success: boolean; message: string; failedIds?: (number | string)[]; ids: (number | string)[] },
  (number | string)[],
  { rejectValue: { message: string; failedIds?: (number | string)[]; ids: (number | string)[] } }
>(
  "[TastePanel] Bulk Delete TastePanel",
  async (ids, thunkAPI) => {
    const res = await tastePanelDataAccess.deleteTastePanelsBulk(ids);

    if (!res.success) {
      return thunkAPI.rejectWithValue({ ...res, ids });
    }

    return { ...res, ids };
  }
);